var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({attrs:{"outlined":"","persistent-placeholder":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._t("item",null,{"item":item})]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._t("selection",null,{"item":item})]}}],null,true)},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }